var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",attrs:{"id":"calendar"}},[_c('h2',[_vm._v("CALENDAR")]),_c('div',{staticClass:"main__container"},[_c('div',{staticClass:"items"},_vm._l((Object.keys(_vm.item)),function(key){return _c('CalendarItem',_vm._b({key:key},'CalendarItem',_vm.item[key],false))}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }